define('editor/export/index',['jquery', 'durandal/app', 'plugins/router', 'plugins/http', 'plugins/dialog', 'knockout', 'bowser'], function ($, app, router, http, dialog, ko, bowser) {
    var viewmodel = function () {
        var self = this;
        
        self.router = router;
        self.id = ko.observable(0);
        self.title = ko.observable('');
        self.browserSummary = ko.observable('');
        self.path = ko.observable('');
        self.loading = ko.observable(true);

        self.formattedInstructions = ko.observable('');
        self.numberedMarkerText = ko.observable('');

        self.formatRouteLegs = function (legs) {
            var formatted = '',
                legsLen = legs.length;

            formatted += name;
            formatted += '\r\n';
            formatted += '\r\n';

            for (var i = 0; i < legsLen; i++) {
                var leg = legs[i],
                    maneuversLen = leg.maneuvers.length;

                if (legsLen > 1) {
                    if (i) {
                        formatted += '\r\n';
                    }

                    formatted += 'Leg ' + (i + 1) + '\r\n';
                }

                for (var j = 0; j < maneuversLen; j++) {
                    var maneuver = leg.maneuvers[j],
                        line;
                    
                    line = (j + 1) + ') ' +
                        maneuver.narrative +
                        ' (' + maneuver.distance.toFixed(2) + ' miles)' +
                        '\r\n';

                    formatted += line;
                }
            }

            formatted += '\r\n';
            formatted += '\r\n';

            return formatted;
        };
        
        self.shouldShowRouteInstructions = ko.computed(function () {
            return self.formattedInstructions().length > 0;
        });
        
        self.shouldShowNumberedMarkers = ko.computed(function () {
            return self.numberedMarkerText().length > 0;
        });
        
        self.edit = function () {
            router.navigate('/editor/edit/' + self.id());
        };

        self.list = function () {
            router.navigate('/editor/list');
        };

        self.selectUrl = function (vm, ev) {
            if (window.getSelection) {
                var range = document.createRange();
                range.selectNode(ev.currentTarget.childNodes[0]);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        };

        self.highlightRouteInstructions = function () {
            var textarea = $('#instructions'),
                message = $('#copy-message-instructions');

            textarea.focus();
            textarea.select();
            message.show();

            textarea.bind({
                'copy': function() {
                    message.text("Copied!");
                }
            });
        };

        self.highlightNumberedMarkerText = function () {
            var textarea = $('#auto-number-text'),
                message = $('#copy-message-numbered');

            textarea.focus();
            textarea.select();
            message.show();

            textarea.bind({
                'copy': function() {
                    message.text("Copied!");
                }
            });
        };

        self.activate = function (id) {
            self.id(id);
            
            self.getMapLayers()
                .then(self.processMarkerLayers)
                .then(self.processDirectionsLayers);
        };
        
        self.compositionComplete = function () {
            var browser = {
                name: bowser.name,
                version: bowser.version
            };

            var url = '/api/editor/export/' + self.id() + '/' + browser.name + '/' + browser.version + '/'; // leading slash ensures versions with a . still hit the nancy module route

            return http.get(url).then(function (response) {
                if (response.success) {
                    var jobId = response.data.jobId;

                    self.title(response.data.title);
                    self.scheduleExportImageRequest(jobId);

                    self.setFormattedBrowserSummary(response.data.browserSummary);
                }
            }).fail(app.showError);
        };

        self.setFormattedBrowserSummary = function (summary) {
            var formattedSummary = 'Your screenshot has been taken on ' + summary;

            self.browserSummary(formattedSummary);
        };

        self.getExportImage = function (jobId) {
            var url = '/api/editor/export-image/' + self.id() + '/' + jobId;

            return http.get(url).then(function (response) {
                if (response.success && response.data.path) {
                    self.path(response.data.path);
                    self.loading(false);
                }
                else {
                    self.scheduleExportImageRequest(jobId);
                }
            }).fail(app.showError);
        };

        self.scheduleExportImageRequest = function (jobId) {
            var callback = function () {
                self.getExportImage(jobId);
            };

            window.setTimeout(callback, 5000); // 5 seconds
        };

        self.getMapLayers = function () {
            var layersUrl = "/api/editor/layers",
                data = {
                    editorMapId: self.id()
                };
            
            if (self.router.activeInstruction() && self.router.activeInstruction().queryString) {
                layersUrl += '?' + self.router.activeInstruction().queryString;
            }

            return http.get(layersUrl, data)
                .then(function(response) {
                    if (response.data) {
                        self.layers = response.data.layers;
                    }
                })
                .fail(app.showError);
        };
        
        self.processMarkerLayers = function () {
            var groupIds = ko.utils.arrayMap(self.layers, function (layer) {
                return layer.groupId;
            });
            var uniqueGroupIds = ko.utils.arrayGetDistinctValues(groupIds);

            for (var j = 0; j < uniqueGroupIds.length; j++) {

                var markers = ko.utils.arrayFilter(self.layers, function(layer) {
                    return layer.groupId === uniqueGroupIds[j] && layer.type === 'Marker';
                });

                if (markers.length && markers[0].state.isAutoNumber) {
                    self.numberedMarkerText(self.numberedMarkerText() + (markers[0].groupName + '\n'));
                }
                for (var k = 0; k < markers.length; k++) {
                    if (markers[k].state.isAutoNumber) {
                        self.numberedMarkerText(self.numberedMarkerText() + ((k + 1) + ' - ' + markers[k].state.html + '\n'));
                    }
                }
                if (markers.length && markers[0].state.isAutoNumber) {
                    self.numberedMarkerText(self.numberedMarkerText() + '\n');
                }
            }

            return false;
        };
        
        self.processDirectionsLayers = function () {
            var layersLen = self.layers.length;

            for (var i = 0; i < layersLen; i++) {
                var layer = self.layers[i];

                if (layer.type === "Directions") {
                    self.fetchRouteInstructions(layer);
                }
            }

            return false;
        };

        self.fetchRouteInstructions = function (layer) {
            var url = "/api/geo/route/instructions",
                data = {
                    waypoints: layer.state.waypoints,
                    travelMode: layer.state.travelMode
                };

            return http.post(url, data)
                .then(function (response) {
                    self.formattedInstructions(self.formattedInstructions() + layer.name);
                    
                    var instructions = self.formatRouteLegs(response.data.instructions.routeLegs);

                    self.formattedInstructions(self.formattedInstructions() + instructions);
                })
                .fail(app.showError);
        };
    };

    return viewmodel;
});
